module.exports = __webpack_public_path__ + "static/media/emptyfitness.be9cb385.jpg";